import { createAsyncThunk } from '@reduxjs/toolkit';

import { asyncUtils } from 'src/shared/toolbox/asyncUtils';

export const loadingPage = createAsyncThunk('pageLoader/loadingPage', async (durationMs?: number) => {
	return asyncUtils.createDelay(durationMs ?? 1000);
});
